import { connect } from 'react-redux';
import editSectionAction from '../../actions/compose-report-tool/edit-section';

import ComposeReportEditor from './component';

const mapStateToProps = state => ({
    // selectproduct: state.selectproduct.get('selectproduct'),
    selectedsections: state.selectedsections.get('selectedsections'),
});

const mapDispatchToProps = dispatch => ({
    editSection: async (section) => {
        await dispatch(await editSectionAction(section));
    },
});

export default connect(mapStateToProps, mapDispatchToProps)(ComposeReportEditor);
